import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { getHHToken, updateHHToken } from './services/api.ts';

const AdminStatistics = () => {
  const [loading, setLoading] = useState(false);
  const [hhStatus, setHhStatus] = useState(null);
  const [newToken, setNewToken] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const status = await getHHToken();
        setHhStatus(status || null);
      } catch (e) {
        toast.error('Не удалось загрузить статус HH токена');
      } finally {
        setLoading(false);
      }
    };
    void load();
  }, []);

  const handleSave = async () => {
    if (!newToken || newToken.trim().length === 0) {
      toast.error('Введите токен HH');
      return;
    }
    try {
      setSaving(true);
      await updateHHToken(newToken.trim());
      toast.success('Токен HH обновлён');
      setNewToken('');
      const status = await getHHToken();
      setHhStatus(status || null);
    } catch (e) {
      toast.error('Ошибка сохранения токена HH');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <div className="px-4 sm:px-6 lg:px-8">
        <h2 className="text-lg font-medium text-gray-900">Настройки интеграций</h2>
        <div className="mt-6 grid grid-cols-1 gap-6">
          <div className="bg-white rounded-xl border border-gray-200 p-6">
            <h3 className="text-base font-medium text-gray-900 mb-2">HH.ru токен</h3>
            <p className="text-sm text-gray-500 mb-4">Установите или обновите токен доступа для интеграции с HH.ru.</p>

            <div className="space-y-3">
              <div className="text-sm">
                <span className="text-gray-500 mr-2">Текущий статус:</span>
                {loading ? (
                  <span className="text-gray-700">Загрузка...</span>
                ) : hhStatus ? (
                  <span className="text-gray-900">{hhStatus.tokenMasked || 'установлен'}</span>
                ) : (
                  <span className="text-gray-900">не установлен</span>
                )}
              </div>
              {hhStatus?.updatedAt && (
                <div className="text-sm text-gray-500">Обновлён: {new Date(hhStatus.updatedAt).toLocaleString('ru-RU')}</div>
              )}

              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Новый токен HH</label>
                <input
                  type="password"
                  value={newToken}
                  onChange={(e) => setNewToken(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Вставьте токен HH"
                />
                <div className="mt-3">
                  <button
                    onClick={handleSave}
                    disabled={saving}
                    className={`inline-flex items-center px-4 py-2 rounded-md text-white ${saving ? 'bg-indigo-300' : 'bg-indigo-600 hover:bg-indigo-700'} focus:outline-none focus:ring-2 focus:ring-indigo-500`}
                  >
                    {saving ? 'Сохранение...' : 'Сохранить токен'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminStatistics;